import { useInvalidateOrderInquiries } from '@/entities/order-inquiry';
import { trpc } from '@/shared/api';
import { getOrderInquiryErrorCode, useAsyncAction } from '@/shared/lib';

export const useAnswerOrderInquiry = () => {
  const mutation = trpc.orderInquiryManagement.answer.useMutation();
  const invalidate = useInvalidateOrderInquiries();
  // 다른 운영자가 먼저 답했으면(CONFLICT) 상세를 다시 불러 그 답변을 보여 준다 — 상세는 staleTime 무한이다.
  const answerOnce: typeof mutation.mutateAsync = async (input, options) => {
    try {
      return await mutation.mutateAsync(input, options);
    } catch (cause) {
      if (getOrderInquiryErrorCode(cause) === 'CONFLICT') invalidate();
      throw cause;
    }
  };
  const action = useAsyncAction(answerOnce, invalidate);
  return { ...action, answer: action.execute };
};
